import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const TalkingPointsPage = loadAsyncComponent(() => import('./Container'), 'page');
